import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import SydInput from '../../../../../commonDesign/SydInput'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    gap: '16px'
  },
  field: {
    flex: 1
  },
  label: {
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--text-color-subtle)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px'
  },
  required: {
    color: 'var(--color-danger-400)',
    marginLeft: '2px'
  }
}))

function PipelineConfig ({ actionPipelineCode, dataPipelineCode, onChange }) {
  const classes = useStyles()
  const handleChange = useCallback((field) => (e) => {
    onChange(field, e.target.value)
  }, [onChange])

  return (
    <div className={classes.root}>
      <div className={classes.field}>
        <div className={classes.label}>Action Pipeline Code<span className={classes.required}>*</span></div>
        <SydInput
          value={actionPipelineCode}
          onChange={handleChange('actionPipelineCode')}
          placeholder='e.g. se:my-action:live'
        />
      </div>
      <div className={classes.field}>
        <div className={classes.label}>Data Pipeline Code</div>
        <SydInput
          value={dataPipelineCode}
          onChange={handleChange('dataPipelineCode')}
          placeholder='e.g. se:my-init-pipeline:live'
        />
      </div>
    </div>
  )
}

PipelineConfig.propTypes = {
  actionPipelineCode: PropTypes.string,
  dataPipelineCode: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default PipelineConfig
